/* eslint-disable no-shadow */
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import {
  Grid,
  Button,
  Typography,
  IconButton,
  useMediaQuery,
} from '@mui/material';
import { KeyboardArrowLeft } from '@mui/icons-material';
import Card from '@src/components/Card';
import ROUTES from '@src/constants/route';
import { useCheckDubbingRoute } from '@src/hooks/useCheckDubbingRoute';

import { getPackageCurrentPrice } from '@src/services/package';

import theme from '@src/styles/theme';
import { BREAKPOINTS } from '@src/styles/config';
import PackageInfo from './PackageInfo';

import OrderInfo from './OrderInfo';
import PaymentMethods from './PaymentMethods';
import PaymentFooter from './PaymentFooter';

import { StyledPayment } from './index.style';
import SMSRegisterDialog from '../Dialog/SMSDialog/SMSRegister';

const PaymentSMS = () => {
  const isMobile = useMediaQuery(theme.breakpoints.down(BREAKPOINTS.SMD));
  const isDubbingRoute = useCheckDubbingRoute();
  const history = useHistory();
  const { t } = useTranslation();

  const [openDialog, setOpenDialog] = useState(null);
  const [selectedPackageCode, setSelectedPackageCode] = useState('');
  const [isPhoneNumberValid, setIsPhoneNumberValid] = useState(true);

  const [checkedAgreeTermAutoRenew, setCheckedAgreeTermAutoRenew] =
    useState(false);
  const [errorNotCheckAgreeTermAutoRenew, setErrorNotCheckAgreeTermAutoRenew] =
    useState(false);

  const handleChangeSelectedPackageCode = (value) =>
    setSelectedPackageCode(value);
  const handleChangeIsPhoneNumberValid = (value) =>
    setIsPhoneNumberValid(value);

  const { openSidebar } = useSelector((state) => state.layout);
  const { package: packageState } = useSelector((state) => state.order);

  const handleRedirectToPackage = () =>
    history.push(isDubbingRoute ? ROUTES.PAYMENT_DUBBING : ROUTES.PAYMENT);

  const { price: currPrice } = getPackageCurrentPrice(packageState, true);
  const totalPrice = currPrice;

  const handleCreateOrder = async () => {
    if (!checkedAgreeTermAutoRenew) {
      setErrorNotCheckAgreeTermAutoRenew(true);
      return;
    }

    setOpenDialog(true);
  };

  return (
    <>
      <StyledPayment openSidebar={openSidebar}>
        <div className="header-payment">
          <Button
            variant="contained"
            startIcon={<KeyboardArrowLeft />}
            className="back-to-package icon website-button"
            onClick={handleRedirectToPackage}
          >
            {t('backToPackage')}
          </Button>
          <IconButton
            variant="contained"
            className="back-to-package icon medium-website-button"
            onClick={handleRedirectToPackage}
          >
            <KeyboardArrowLeft />
          </IconButton>
          <KeyboardArrowLeft
            className="back-to-package-mobile mobile-button"
            onClick={handleRedirectToPackage}
          />

          {isMobile ? (
            <Typography onClick={handleRedirectToPackage} className="title">
              {t('backToPackage')}
            </Typography>
          ) : (
            <Typography className="title">{t('payment')}</Typography>
          )}
        </div>
        <Grid container spacing={2}>
          <Grid item xs={12} mlg={openSidebar ? 12 : 6} cmlg={6}>
            <Card className="card">
              <PackageInfo
                selectedPackageCode={selectedPackageCode}
                onChangeSelectedPackageCode={handleChangeSelectedPackageCode}
              />
              <PaymentMethods />
              <div className="show-mobile">
                <OrderInfo
                  totalPrice={totalPrice}
                  isPhoneNumberValid={isPhoneNumberValid}
                  onChangePhoneNumberValid={handleChangeIsPhoneNumberValid}
                />
              </div>
            </Card>
          </Grid>
          <Grid item xs={6}>
            <Card className="card show-desktop">
              <OrderInfo
                totalPrice={totalPrice}
                isPhoneNumberValid={isPhoneNumberValid}
                onChangePhoneNumberValid={handleChangeIsPhoneNumberValid}
              />
            </Card>
          </Grid>
        </Grid>
      </StyledPayment>
      <PaymentFooter
        checkedAgreeTermAutoRenew={checkedAgreeTermAutoRenew}
        setCheckedAgreeTermAutoRenew={setCheckedAgreeTermAutoRenew}
        totalPrice={totalPrice}
        onCreateOrder={handleCreateOrder}
        errorNotCheckAgreeTermAutoRenew={errorNotCheckAgreeTermAutoRenew}
        setErrorNotCheckAgreeTermAutoRenew={setErrorNotCheckAgreeTermAutoRenew}
      />

      {openDialog && (
        <SMSRegisterDialog
          packageState={packageState}
          openDialog={openDialog}
          setOpenDialog={setOpenDialog}
        />
      )}
    </>
  );
};

export default PaymentSMS;
